/**
 * Created by Federico Brocco on 07/12/2023.
 *
 * @format
 */

/**
 * Recupera l'elenco dei tipi di modulistica disponibili
 * @returns {Promise<Array>} Promise che risolve con un array di tipi di modulistica
 */
let list = function () {
    return new Promise(function (resolve, reject) {
        fetch(window.route.modules, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('chiamata api: ', window.route.modules);
                console.log('API modules list', responseJson);
                resolve(responseJson.tipi_modulistica);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

/**
 * Recupera i tipi di pratica ONLINE abilitati per il cliente corrente.
 * Endpoint backend (Gianmaria): GET /tipo_modulistica_online/<comune> — restituisce
 * solo i tipi con `abilitato IS TRUE`, ciascuno con `code` (chiave dell'enum dei form).
 * Richiede autenticazione (x-access-token).
 * @returns {Promise<Array>} Promise che risolve con l'array `tipo_modulistica_online`
 */
let listOnline = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');
        if (hash === null) {
            reject("NO_AUTH");
            return;
        }

        fetch(window.route.tipoModulisticaOnline, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API tipo_modulistica_online', responseJson);
                resolve(responseJson.tipo_modulistica_online || []);
            })
            .catch((e) => {
                console.error(e.message);
                reject();
            });
    });
};

/**
 * Recupera i dettagli dei moduli per un tipo specifico
 * @param {string|number} module_type_id - L'ID del tipo di modulistica
 * @returns {Promise<Array>} Promise che risolve con un array di moduli per il tipo specificato
 */
let detail = function (module_type_id) {
    return new Promise(function (resolve, reject) {
        fetch(window.route.module_detail + "?tipo_modulistica_id=" + module_type_id, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API module detail', responseJson.moduli);
                resolve(responseJson.moduli);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};


const ModuleFilesAPI = {
    list: list,
    listOnline: listOnline,
    detail: detail
};

export default ModuleFilesAPI;
